<template>
  <tr class="sortable-row advertising-table-item"
      :id="item.id">

    <td class="px-1 col-sm">
      <v-btn icon
             v-if="sortable"
             class="sort-handle cursor-move">
        <v-icon>mdi-reorder-horizontal</v-icon>
      </v-btn>
    </td>
    <td class="col-sm">
      <img class="imgAdvertisers"
           :src="item.avatar"
           alt=""
           v-tooltip="item.nomeAvatar">
    </td>

    <td class="col-sm">
      <app-toggle v-model="isActive" :disabled="!createCampaign"></app-toggle>
    </td>

    <td v-if="showOrderColumn"
        class="col-sm text-center">

      <span class="pointer"
            v-if="!input"
            v-tooltip="$t('message.campaigns.message.clickToEdit')"
            @click="input = true">
        {{ item.sortingNumber }}
      </span>

      <v-text-field height="40"
                    v-if="input"
                    v-model="item.sortingNumber"
                    @blur="order"
                    @keyup.enter="order"></v-text-field>
    </td>

    <td>{{ item.nome }}</td>
    <td>{{ $date.format(item.dataInicio) }}</td>
    <td>{{ $date.format(item.dataFim) }}</td>
    <td v-if="showLastUpdatedColumn">{{ $date.formatDateAndHour(item.dataUltimaAlteracao) }}</td>
    <td class="advertising-table-item-actions">
      <v-icon v-if="showStandardActions"
              size="20"
              :disabled="!createCampaign"
              slot="activator"
              v-tooltip="$t('message.campaigns.message.repeat')"
              :class="{on: item.repetir}"
              @click="repeat">
        mdi-replay
      </v-icon>

      <v-icon v-if="showStandardActions"
              size="20"
              :disabled="!createCampaign"
              slot="activator"
              v-tooltip="$t('message.generics.message.edit')"
              @click="edit">mdi-settings</v-icon>

      <v-icon size="20"
              :disabled="!createCampaign"
              slot="activator"
              v-tooltip="$t('message.generics.message.duplicate')"
              @click="duplicate">mdi-content-copy</v-icon>

      <v-icon v-if="showStandardActions"
              size="20"
              :disabled="!createCampaign"
              slot="activator"
              v-tooltip="$t('message.generics.message.remove')"
              @click="remove">mdi-delete</v-icon>

      <v-icon size="20"
              slot="activator"
              v-tooltip="$t('message.campaigns.message.previewMobile')"
              @click="openMobilePreview">mdi-play
      </v-icon>

      <v-icon v-if="showStandardActions && !isAllCampaigns"
              size="20"
              :disabled="!createCampaign"
              slot="activator"
              v-tooltip="item.isArchived ? 'Desarquivar campanha' : 'Arquivar campanha'"
              :class="{on: item.isArchived}"
              @click="archive">mdi-archive</v-icon>

      <app-preview ref="preview"
                   :data-advertising-id="item.id"
                   :is-desktop="isDesktopPreview"
                   isCampaignsListPreview></app-preview>
    </td>

    <app-confirmation-modal :value="!!pendingRemoveId"
                            :confirm-label="$t('message.generics.message.remove')"
                            @confirm="confirmRemove"
                            @cancel="pendingRemoveId = null">
      <span slot="heading">
        {{$t('message.campaigns.message.removeCampaign')}}
      </span>
      <span>
        {{$t('message.campaigns.message.removeCampaignConfirmation')}}
      </span>
    </app-confirmation-modal>
  </tr>
</template>

<script>
import AppPreview from "./preview/Preview";
import AppToggle from "@components/Toggle";
import EventBus from "@packages/event-bus";
import AppConfirmationModal from "@components/ConfirmationModal";
import palette from "@packages/colors";

export default {
  components: {
    AppPreview,
    AppToggle,
    AppConfirmationModal,
  },

  data() {
    return {
      pendingRemoveId: null,
      toggleColors: {
        checked: palette.primary,
        unchecked: "#E3E3E3",
        disabled: "#CCCCCC",
      },
      disabled: false,
      input: false,
      isDesktopPreview: false,
    };
  },

  props: {
    dataItem: {
      type: Object,
      required: true,
    },
    sortable: {
      type: Boolean,
      default: true,
    },
    showOrderColumn: {
      type: Boolean,
      default: true,
    },
     showStandardActions: {
      type: Boolean,
      default: true,
    },
    showLastUpdatedColumn: {
      type: Boolean,
      default: true,
    },
     isAllCampaigns: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    item() {
      return this.dataItem;
    },

    isActive: {
      get() {
        return this.item.isAtivo;
      },

      async set(value) {
        this.item.isAtivo = value;

        try {
          await this.$api.advertising.activate(this.item.id);
        } catch (e) {
          this.item.isAtivo = !this.item.isAtivo;
        }
      },
    },

    editUrl() {
      return `/campanhas/${this.item.id}/editar`;
    },

    isEstablishment() {
      return this.$store.state.users.user.tipo === "ESTABELECIMENTO";
    },

    filters() {
      return this.$store.state.advertising.filters;
    },

    user() {
      return this.$store.state.users.user;
    },   

    permissions() {
      return this.user.permissions;
    },

    createCampaign() {
      return this.isPartner || !!this.permissions.find((x) => x === "CREATE_CAMPAIGN")
        
    },

    isPartner() {
      return (
        this.$store.state.users.user &&
        this.$store.state.users.user.tipo === "PARCEIRO"
      );
    },
  },

  methods: {
    openDesktopPreview() {
      this.isDesktopPreview = true;
      this.$refs.preview.start();
    },

    openMobilePreview() {
      this.isDesktopPreview = false;
      this.$refs.preview.start();
    },

    async archive() {
      try {
        await this.$api.advertising.archive(this.item.id);
        this.$emit("change");
      } catch (e) {
        console.log(e);
      }
    },

    edit() {
      EventBus.$emit("edit-advertisement", this.item);
    },

    async repeat() {
      this.item.repetir = !this.item.repetir;

      try {
        await this.$api.advertising.repeat(this.item.id);
      } catch (e) {
        this.item.repetir = !this.item.repetir;
      }
    },

    async confirmRemove() {
      this.request({
        request: this.$api.advertising.remove({ id: this.pendingRemoveId }),
      });

      this.pendingRemoveId = null;
    },

    remove() {
      this.pendingRemoveId = this.item.id;
    },

    duplicate() {
      this.request({
        request: this.$api.advertising.duplicate({ id: this.item.id }),
      });
    },

    order() {
      const request = this.isEstablishment
        ? this.$api.advertising.levelOrder({
            id: this.item.id,
            order: this.item.sortingNumber,
            level: this.filters.level,
          })
        : this.$api.advertising.order({
            id: this.item.id,
            order: this.item.sortingNumber,
          });

      // implement vuetify table editable column
      this.request({
        request,
        then: () => (this.input = false),
        err: () => {
          this.input = false;
          this.$emit("change");
        },
      });
    },

    async request({ request, then, err }) {
      if (this.disabled) return;

      this.disabled = true;

      try {
        await request;

        this.disabled = false;
        this.input = false;
        this.$emit("change");

        if (then) then();
      } catch (e) {
        this.disabled = false;
        this.input = false;

        if (err) err();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";
.imgAdvertisers {
  max-height: 42px;
  border-radius: 10px;
  margin-top: 5px;
}
.on {
  color: $blue-primary;
}

.advertising-table-item {
  .advertising-table-item-actions {
    display: flex;
    align-items: center;

    .advertising-table-item-actions-preview {
      cursor: pointer;
    }
  }
}
</style>
